import { render, staticRenderFns } from "./UpDownCustomerDistribution.vue?vue&type=template&id=73758b65&scoped=true&"
import script from "./UpDownCustomerDistribution.vue?vue&type=script&lang=js&"
export * from "./UpDownCustomerDistribution.vue?vue&type=script&lang=js&"
import style0 from "./UpDownCustomerDistribution.vue?vue&type=style&index=0&id=73758b65&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73758b65",
  null
  
)

export default component.exports